import { useQuery } from "@tanstack/react-query";
import { getMessages } from "../services/services";
import ResponsiveDataList from "../components/ResponsiveDataList/ResponsiveDataList";
import { booleanFormatter } from "../formatters/booleanFormatter";

const MessageList = () => {
  // const { data: messages } = useQuery({
  //   queryKey: ["getMessages"],
  //   queryFn: () => getMessages(),
  //   select: (res) => res.data.result,
  //   staleTime: 60 * 60000,
  //   retry: false,
  //   enabled: true,
  // });
  // const columns = [
  //   {
  //     field: "ID",
  //     header: "شناسه",
  //     style: { textAlign: "right" },
  //   },
  //   {
  //     field: "Name",
  //     header: "نام",
  //     style: { textAlign: "right" },
  //   },
  //   {
  //     field: "CreateDate",
  //     header: "تاریخ عضویت",
  //     sortable: true,
  //     style: { textAlign: "right" },
  //   },
  //   {
  //     field: "PhoneNumber",
  //     header: "شماره موبایل	",
  //     style: { textAlign: "right" },
  //   },
  //   {
  //     field: "Score",
  //     header: "سکه",
  //     sortable: true,
  //     style: { textAlign: "right" },
  //   },
  //   {
  //     field: "InstallCount",
  //     header: "تعداد نصب",
  //     sortable: true,
  //     style: { textAlign: "right" },
  //   },
  //   {
  //     field: "ChargeCount",
  //     header: "تعداد شارژ",
  //     sortable: true,
  //     style: { textAlign: "right" },
  //   },
  //   {
  //     field: "Version",
  //     header: "ورژن اپلیکیشن	",
  //     style: { textAlign: "right" },
  //   },
  //   {
  //     field: "OS",
  //     header: "سیستم عامل	",
  //     style: { textAlign: "right" },
  //   },
  //   {
  //     field: "Name",
  //     body: (rowData) => {
  //       return booleanFormatter(rowData.Registered);
  //     },
  //     header: "تکمیل اطلاعات",
  //     style: { textAlign: "right" },
  //   },
  //   {
  //     field: "RefrenceID",
  //     header: "کدمعرف",
  //     style: { textAlign: "right" },
  //   },
  // ];
  // const itemTemplate = (item) => (
  //   <div
  //     key={item.ID}
  //     className="rounded shadow-sm mb-3 p-3"
  //     style={{ backgroundColor: "#f9f9f9", border: "1px solid #eee" }}
  //   >
  //     <div className="mb-2 d-flex justify-content-between">
  //       <span className="text-muted">شناسه:</span>
  //       <span className="fw-bold farsi-monospace-digit">{item.ID}</span>
  //     </div>
  //   </div>
  // );
  return (
    <div className="custom-container mt-3">
      {/* <div className="card">
        <h5>فهرست پیام ها</h5>
        <ResponsiveDataList
          data={messages}
          columns={columns}
          itemTemplate={itemTemplate}
          dataViewHeader={<></>}
          className="farsi-monospace-digit "
          rows={10}
        />
      </div> */}
    </div>
  );
};
export default MessageList;
